import { NavLink, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import "./admin.css";

const NAV_ITEMS = [
  { to: "/admin/people", label: "People", icon: "👥" },
  { to: "/admin/memories", label: "Memories", icon: "🧠" },
  { to: "/admin/business", label: "Business", icon: "\uD83D\uDCB0" },
  { to: "/admin/grants", label: "Grants", icon: "🎁" },
  { to: "/admin/ai", label: "AI Costs", icon: "🤖" },
  { to: "/admin/ai-debug", label: "AI Debug", icon: "🔬" },
  { to: "/admin/translations", label: "Translations", icon: "\uD83C\uDF10" },
  { to: "/admin/prompts", label: "AI Prompts", icon: "\u2728" },
  { to: "/admin/content", label: "Content Library", icon: "\uD83C\uDCCF" },
  { to: "/admin/card-frequency", label: "Card frequency", icon: "🔁" },
  { to: "/admin/collections", label: "Collections", icon: "\uD83D\uDDC2\uFE0F" },
  { to: "/admin/categories", label: "Categories", icon: "\uD83C\uDFF7\uFE0F" },
  { to: "/admin/acorns", label: "Acorns", icon: "🌰" },
  { to: "/admin/stash", label: "Stash", icon: "📦" },
  { to: "/admin/partners", label: "Partners", icon: "🤝" },
  { to: "/admin/partner-reports", label: "Partner reports", icon: "📈" },
  { to: "/admin/emails", label: "Emails", icon: "✉️" },
  { to: "/admin/feedback", label: "Feedback", icon: "💬" },
  { to: "/admin/audit-log", label: "Audit Log", icon: "🔍" },
  { to: "/admin/memory-metadata", label: "Metadata", icon: "📊" },
];

export default function AdminLayout() {
  return (
    <div className="flex min-h-screen bg-gray-50">
      <Toaster position="top-right" richColors />
      <aside className="w-56 shrink-0 border-r border-gray-200 bg-white">
        <div className="px-4 py-5 border-b border-gray-100">
          <h2 className="text-sm font-semibold text-gray-900 tracking-wide">
            Admin
          </h2>
        </div>
        <nav className="flex flex-col gap-0.5 p-2">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `flex items-center gap-2.5 rounded-md px-3 py-2 text-sm transition-colors ${
                  isActive
                    ? "bg-orange-50 text-orange-700 font-medium"
                    : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                }`
              }
            >
              <span className="text-base">{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
